import { build } from './build-info';
import { IAppEnvironment } from './env.type';

export const environment: IAppEnvironment = {
    build,
    stage: 'production',
    production: true,
    sandbox: false,
    clientId: 'StudioJS',
    sentry: {
        tracesSampleRate: 0.1,
        enabled: true
    },
    appInsights: {
        instrumentationKey: '805f97b4-921e-4d2c-ad99-1382c5cc0261',
        samplingPercentage: 33,
        enabled: true
    },
    signalR: {
        enabled: true,
        url: 'https://studio.bannerflow.com/hub'
    },
    intercomId: 'vc7jxmzv',
    gtmId: 'GTM-W5CTW5Z',
    origins: {
        acg: 'https://studio.bannerflow.com/creatives',
        b2: 'https://app.bannerflow.com',
        bannerlingo: 'https://bls.bannerflow.com',
        bfc: 'https://home.bannerflow.com',
        bannerflowLibrary: 'https://bf-bannerflowlibrary-euwest.azurewebsites.net',
        campaignManager: 'https://cm.bannerflow.com',
        campaignService: 'https://campaignservice.bannerflow.com',
        commentService: 'https://commentserviceapi.bannerflow.com',
        feedStorage: 'https://c.bannerflow.net/sfeeds',
        fontManager: 'https://fontmanager.bannerflow.com',
        fontManagerApi: 'https://fontmanagerapi.bannerflow.com',
        fontService: 'https://c.bannerflow.net/fs',
        fontStorage: 'https://fonts.bannerflow.net',
        videoStorage: 'https://c.bannerflow.net',
        listService: 'https://listservice.bannerflow.com',
        idp: 'https://idp.bannerflow.com',
        imageOptimizer: 'https://c.bannerflow.net/io',
        sapi: 'https://studio.bannerflow.com/api',
        socialCampaignManager: 'https://scm.bannerflow.com',
        socialCampaignService: 'https://scm.bannerflow.com',
        studioBlobStorage: 'https://c.bannerflow.net',
        videoConverter: 'https://videoconverter.bannerflow.com',
        zipOrchestration: 'https://zorc.bannerflow.com'
    },
    commentServiceCreativeToken: '3b15c66f-e3f8-4f12-b2af-3d5a27222dfb',
    commentServiceCreativesetToken: '4d215810-4945-4ce2-8df0-06d3b13c06fe'
};
